module.exports = {"contacts":"Contatti","privacy":"Privacy","credits":"Credits","Home":"Home","Servizi":"Servizi","Ambiti":"Ambiti","Numeri":"Numeri","Tecnologia":"Tecnologia","Case Studies":"Case Studies","Network":"Network","Contatti":"Contatti"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/it.json
// module id = HuST
// module chunks = 1